// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import Vant from 'vant'
import 'vant/lib/index.css';

import wx from "weixin-jsapi";
// import wx from 'weixin-js-sdk';
import VueClipboard from 'vue-clipboard2'
import Meta from 'vue-meta'
import Axios from 'axios';
import App from './App'
import router from './router'

// import * as echarts from "echarts";
// Vue.prototype.$echarts = echarts;


import Clipboard from 'v-clipboard'

Vue.use(Clipboard)
import Mint from 'mint-ui';
Vue.use(Mint);
import { DatetimePicker } from 'mint-ui';
Vue.component(DatetimePicker.name, DatetimePicker);

import vSelect from 'vselect-component'


Vue.use(vSelect)
Vue.use(ElementUI)
Vue.use(Meta)
Vue.use(Vant);
Vue.use(VueClipboard)
Vue.prototype.wx = wx
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

Vue.prototype.$axios = Axios;


Vue.mixin({
    beforeCreate() {
        const options = this.$options;

        this.$hm = options.parent && options.parent.$hm ?
            options.parent.$hm :
            (function(window) {
                if (!window._hmt) {
                    return;
                }
                return Object.assign({}, window._hmt, { // 统计页面的点击事件
                    click: (category, val) => {
                        const userInfo = store.getters.userInfo || {};
                        return window._hmt.push([
                            '_trackEvent',
                            category,
                            'click',
                            userInfo.loginName || 'notLogin',
                            val
                        ]);
                    }
                });
            })(window);
    }
});

Vue.prototype.myLoading = function() {
    const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
    });
    return loading;
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});
// wx.config({
//   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//   appId: PageHelper.Inst.appid2, // 必填，公众号的唯一标识
//   timestamp: timestamp, // 必填，生成签名的时间戳
//   nonceStr: nonceStr, // 必填，生成签名的随机串
//   signature: signature, // 必填，签名
//   openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
// })


// WEBPACK FOOTER //
// ./src/main.js